import { styled } from '@mui/material/styles';
import { NumericField, Select, TextField } from '../../form';

export const TableNumericField = styled(NumericField)<{ textalign?: 'right' | 'left' }>(
  ({ textalign }) => ({
    height: '100%',
    '& > div': {
      fontSize: 'inherit',
    },
    '& input': {
      padding: 0,
      textAlign: textalign || 'right',
      paddingRight: 16,
      paddingLeft: 16,
    },
    '& fieldset': {
      border: 'none',
    },
  }),
);

export const TableSelect = styled(Select)<{ height?: string }>(({ height }) => ({
  '& fieldset': {
    border: 'none',
  },
  '& input': {
    fontSize: 14,
    ...(height && {
      height: `calc(${height} - 12px)`,
    }),
  },
}));

export const TableTextField = styled(TextField)({
  '& fieldset': {
    border: 'none',
  },
  '& input': {
    fontSize: 14,
  },
});
